import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import PageSection from '../Common/PageSection';
import * as styles from './TestimonialSection.module.css';

const borders = { 'Light Teal': '#0FA69D', 'Light Blue': '#009CE2', Pink: '#F8598B' };

const TestimonialTop = ({ testimonial }) => {
  let border = borders[testimonial.backgroundColor];
  return (
    <div className={styles.quoteContainer} style={{ '--border-color': border }}>
      <div className={styles.logo}>
        <ContentfulImage imageFragment={testimonial.logo} />
      </div>
      <p>{testimonial.quote?.quote}</p>
    </div>
  );
};

const TestimonialBottom = ({ testimonial, itemsPerRow }) => {
  let border = borders[testimonial.backgroundColor];
  return (
    <div className={styles.bottom} style={{ '--border-color': border }}>
      <div className={styles.attribution} style={{ '--attr-pad': itemsPerRow === 2 ? '1rem 56px' : '1rem 1rem 0px' }}>
        <span className={styles.name}>{testimonial.attribution}</span>
        <span>{testimonial.company}</span>
      </div>
      <div className={styles.slantedBorder}>
        <hr />
      </div>
      <div className={styles.empty} />
    </div>
  );
};

const TestimonialSection = ({ testimonials, itemsPerRow = 2, backgroundColor = 'Dark Blue' }) => {
  const backgrounds = { 'Dark Blue': styles.darkBlue };
  return (
    <PageSection className={backgrounds[backgroundColor]}>
      <div className={styles.cardGrid} style={{ '--grid-count': itemsPerRow }}>
        {testimonials.map((t, i) => (
          <TestimonialTop key={i} testimonial={t} />
        ))}
        {testimonials.map((t, i) => (
          <TestimonialBottom key={i} testimonial={t} itemsPerRow={itemsPerRow} />
        ))}
      </div>
      <div className={styles.cardGridMobile} style={{ '--grid-count': itemsPerRow }}>
        {testimonials.map((t, i) => (
          <>
            <TestimonialTop key={i} testimonial={t} />
            <TestimonialBottom key={i} testimonial={t} itemsPerRow={itemsPerRow} />
          </>
        ))}
      </div>
    </PageSection>
  );
};

TestimonialSection.propTypes = {
  testimonials: PropTypes.array.isRequired,
  itemsPerRow: PropTypes.number,
  backgroundColor: PropTypes.string,
};

export default TestimonialSection;
